/**
 * U15 F1 e F2: a ajuda de cada tela do Portal. Texto estático do próprio portal (namespace `portal`, chave `ajuda.<tela>`);
 * o cliente não tem Treinamento. A "primeira visita" fica no aparelho (localStorage), uma marca por tela.
 */
export type TelaAjuda = 'hoje' | 'financeiro' | 'mensagens' | 'documentos' | 'perfil';

export const TELAS_AJUDA: readonly TelaAjuda[] = ['hoje', 'financeiro', 'mensagens', 'documentos', 'perfil'];

/** Tela da rota atual que tem ajuda. Relatórios, Empresas e o acesso de saída não têm (null: o botão não aparece). */
export function telaDaRota(caminho: string, saida = false): TelaAjuda | null {
  if (caminho === '/') return saida ? null : 'hoje';
  const primeiro = caminho.split('/')[1] ?? '';
  return primeiro !== 'hoje' && (TELAS_AJUDA as readonly string[]).includes(primeiro) ? (primeiro as TelaAjuda) : null;
}

export const chaveVisto = (tela: TelaAjuda) => `malgo.portal.ajuda.${tela}`;

/**
 * U15 F2: registra a primeira visita à tela. Só devolve `true` (abrir sozinho) quando a marca não existia e foi gravada agora;
 * sem storage (modo privado, bloqueado) devolve `false`: a ajuda nunca abre sozinha a cada visita, só pelo botão.
 */
export function registrarPrimeiraVisita(tela: TelaAjuda): boolean {
  try {
    if (localStorage.getItem(chaveVisto(tela)) !== null) return false;
    localStorage.setItem(chaveVisto(tela), '1');
    return localStorage.getItem(chaveVisto(tela)) === '1';
  } catch {
    return false;
  }
}

/** U15 F2: "Mostrar de novo na próxima visita" limpa a marca daquela tela. Devolve se conseguiu. */
export function mostrarDeNovo(tela: TelaAjuda): boolean {
  try {
    localStorage.removeItem(chaveVisto(tela));
    return localStorage.getItem(chaveVisto(tela)) === null;
  } catch {
    return false;
  }
}
